<template>
  <div>
    <integration-tasks-table
      :integration-id="model.id"
      :task-identifiers="[
        'optimove_attributes_sync',
        'optimove_campaign_execute',
        'optimove_campaign_pre_execute',
        'optimove_suppression_attributes_sync',
        'optimove_suppression_attributes_import',
        'optimove_list_update'
      ]"
    />
  </div>
</template>

<script>
import IntegrationTasksTable from '@/modules/integrations/components/IntegrationTasksTable'
import RestApi from '@/core/services/RestApi'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'OptimoveTasks',

  components: {
    IntegrationTasksTable
  },

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      lastSyncData: null,
      lastSyncDataLoading: false
    }
  },

  mounted() {
    if (this.model.id) {
      this.lastSyncDataLoading = true
      let asyncDateEndpoint = projectEndpoint({
        method: 'get',
        url: `task-histories`,
        params: {
          sort: '-create_time',
          integration_id: this.model.id,
          'per-page': 1
        }
      })

      RestApi(asyncDateEndpoint)
        .then(({ data }) => {
          if ({ data }.data.length !== 0) {
            this.lastSyncData = data[0].create_time
            this.lastSyncDataLoading = false
          }
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
          this.lastSyncDataLoading = false
        })
    }
  }
}
</script>

<style scoped>
.sync-date {
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/types/optimove/OptimoveTasks.vue